/**
 * @author Hiroki Moto
 * @description https://marvelapp.com/4g4b5dg/screen/55348072
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import clone from 'ramda/src/clone';
import equals from 'ramda/src/equals';
import find from 'ramda/src/find';
import findIndex from 'ramda/src/findIndex';
import isEmpty from 'ramda/src/isEmpty';
import isNil from 'ramda/src/isNil';
import length from 'ramda/src/length';
import move from 'ramda/src/move';
import path from 'ramda/src/path';
import propEq from 'ramda/src/propEq';
import remove from 'ramda/src/remove';
import reverse from 'ramda/src/reverse';
import Button from '@components/@core/AnimatedButton';
import Dropdown from '@components/@core/Dropdown';
import EditDropdown from '@components/EditDropdown';
import Filter from '@components/@core/Filter';
import Input from '@components/@core/Input';
import Settings from '@components/@core/Settings';
import { LibraryToDoScorecardMenu, ScoreCardTypes } from '~/services/config';
import Quota from './Quota';

class Edit extends Component {
    state = { scorecard: this.props.data, quotas: null, visible: false };

    static getDerivedStateFromProps(nextProps, prevState) {
        const { data, modalData } = nextProps;
        let { scorecard } = prevState;
        if (isNil(scorecard)) scorecard = data;
        if (isNil(prevState.quotas)) {
            if (data?.data) {
                const card = nextProps?.history?.location?.state?.card;
                if (data?.data?.quotas?.length > 0) {
                    const quota = data.data.quotas[0];
                    if (!isNil(quota.data)) {
                        let quotas = clone(data.data.quotas);
                        if (card) quotas.push(card);
                        return { quotas };
                    }
                } else {
                    let quotas = clone(data.data.quotas);
                    if (card) quotas.push(card);
                    return { quotas };
                }
                return { scorecard };
            }
        }
        if (modalData.after) {
            const { quotas } = modalData.after;
            if (quotas) {
                const { data } = nextProps;
                if (!equals(data.data.quotas, quotas)) {
                    return { quotas, visible: true };
                }
            }
        }
        return null;
    }

    componentDidUpdate(prevState) {
        const { visible } = this.state;
        if (visible && !prevState.visible) {
            this.handleAddQuotas();
            this.setState({ visible: false });
        }
    }

    handleAddQuotas = () => {
        const { quotas, scorecard } = this.state;
        this.props.onModal({
            type: 'Attach Library',
            data: { before: { show: ['quotas'], modules: [], selected: quotas, quotaType: scorecard.type } },
            callBack: {
                onAttach: (e) => this.setState({ quotas: e.templates }),
                onAdd: () => this.handleNewQuota(),
            },
        });
    };

    handleNewQuota = () => {
        const { quotas, scorecard } = this.state;
        const after = {
            type: 'MODAL_REQUEST',
            payload: {
                type: 'Attach Library',
                data: { before: { show: ['quotas'], modules: [], selected: quotas, quotaType: scorecard.type } },
                callBack: {
                    onAttach: (e) => this.setState({ quotas: e.templates }),
                    onAdd: () => this.handleNewQuota(),
                },
            },
        };
        this.props.onModal({ type: 'Add New Quota', data: { before: { after }, after: { quotas } } });
    };

    handleChangeQuota = (ind) => (type, e) => {
        if (type == 'stars') {
            const quota = this.state.quotas[ind];
            this.props.onModal({
                type: 'Add Quota Stars',
                data: {
                    before: {
                        title: quota.name,
                        unit: quota.data.target_types,
                        direction: quota.quota_direction,
                    },
                    after: e,
                },
                callBack: {
                    onYes: (stars) => {
                        const quotas = clone(this.state.quotas);
                        quotas[ind].star_values = stars;
                        this.setState({ quotas });
                    },
                },
            });
        }
        if (type == 'type') {
            const quotas = clone(this.state.quotas);
            quotas[ind].data.target_types = e.name;
            this.setState({ quotas });
        }
        if (type == 'source') {
            const quotas = clone(this.state.quotas);
            quotas[ind].data.source = e.name;
            this.setState({ quotas });
        }
    };

    handleChangeScorecard = (type) => (e) => {
        const { scorecard } = this.state;
        if (type == 'title') {
            this.setState({ scorecard: { ...scorecard, [type]: e } });
        } else if (type == 'description') {
            this.setState({ scorecard: { ...scorecard, data: { ...scorecard.data, [type]: e } } });
        } else if (type === 'type') {
            this.setState({ scorecard: { ...scorecard, [type]: e[0] } });
        }
    };

    handleSelectMenu = (quota) => (event) => {
        const quotaLen = length(this.state.quotas);
        let quotas = clone(this.state.quotas);
        const indx = findIndex(propEq('id', quota.id), quotas);
        if (indx < 0) return;

        switch (event) {
            case 'move up':
                if (indx !== 0) quotas = move(indx, indx - 1, quotas);
                break;
            case 'move down':
                if (quotaLen !== indx + 1) quotas = move(indx, indx + 1, quotas);
                break;
            case 'remove':
                quotas = remove(indx, 1, quotas);
                break;
            case 'edit':
                const e = quota.star_values;
                this.props.onModal({
                    type: 'Add Quota Stars',
                    data: {
                        before: {
                            title: quota.name,
                            unit: quota.data.target_types,
                            direction: quota.quota_direction,
                        },
                        after: e,
                    },
                    callBack: {
                        onYes: (stars) => {
                            quotas[indx].star_values = stars;
                            this.setState({ quotas });
                        },
                    },
                });
                break;
            default:
                break;
        }
        this.setState({ quotas });
    };

    handleSettings = (type) => (e) => {
        const { scorecard } = this.state;
        if (type == 'author_id') {
            this.setState({ scorecard: { ...scorecard, author_id: e[0] } });
        } else {
            this.setState({ scorecard: { ...scorecard, data: { ...scorecard.data, [type]: e } } });
        }
    };

    handleSubmit = (published) => () => {
        const { scorecard } = this.state;
        let isValid = true;
        const quotas = this.state.quotas.map((quota) => {
            let stars = quota.star_values;
            if (isNil(stars)) {
                isValid = false;
            } else {
                if (quota.quota_direction === 1 && quota.star_values[0] > quota.star_values[1]) {
                    stars = reverse(quota.star_values);
                }
                if (quota.quota_direction === 2 && quota.star_values[0] < quota.star_values[1]) {
                    stars = reverse(quota.star_values);
                }
            }

            return {
                quota_template_id: quota.quota_template_id || quota.id,
                star_values: stars,
            };
        });
        if (!isValid) {
            toast.error('You missed quota scale. \nPlease add the scale and then try it again.', {
                position: toast.POSITION.TOP_RIGHT,
                pauseOnFocusLoss: false,
                hideProgressBar: true,
            });
            return;
        }
        const payload = {
            scorecard: {
                ...scorecard,
                data: { ...scorecard.data, quotas },
                published,
            },
        };
        this.props.onSubmit(payload);
    };

    render() {
        const { authors, data, departments, competencies, categories, userRole, onSelect } = this.props;
        const { scorecard, quotas } = this.state;

        if (isNil(scorecard) || isEmpty(scorecard)) return null;

        const stars = quotas ? find((x) => isNil(x.star_values), quotas) : null;
        const disabled =
            isEmpty(scorecard.title) ||
            isEmpty(scorecard.data.description) ||
            (equals(scorecard.title, this.props.data.title) &&
                equals(scorecard.type, this.props.data.type) &&
                equals(scorecard.data.description, this.props.data.data.description) &&
                equals(this.props.data.data.quotas, quotas) &&
                equals(this.props.data.author_id, scorecard.author_id) &&
                equals(this.props.data.data.department, scorecard.data.department) &&
                equals(this.props.data.data.competency, scorecard.data.competency) &&
                equals(this.props.data.data.category, scorecard.data.category));

        const dropDown = LibraryToDoScorecardMenu[userRole].filter((el) => el !== 'Edit');

        const settings = [
            { name: 'Author', id: path(['author_id'], scorecard) ? [path(['author_id'], scorecard)] : null, options: authors, select: 'author_id' },
            { name: 'Departments', id: data.data?.department, options: departments, select: 'department' },
            { name: 'Competencies', id: data.data?.competency, options: competencies, select: 'competency' },
            { name: 'Categories', id: data.data?.category, options: categories, select: 'category' },
        ];

        return (
            <>
                <Filter back="all scorecards" />
                <div className="lib-todo-scorecard" data-cy="editScorecardForm">
                    <div className="scorecard-detail">
                        <div className="section">
                            <div className="d-h-between mb-2">
                                <p className="dsl-b18 bold mb-0">Scorecard</p>
                                <div className="d-h-end">
                                    <EditDropdown dataCy="topthreedotDropdown" options={scorecard.published != '0' ? dropDown : ['Detail View']} onChange={onSelect} />
                                </div>
                            </div>
                            <Input
                                className="input-field mb-2 title"
                                title="Name"
                                type="text"
                                dataCy="title"
                                maxLength="30"
                                value={scorecard.title}
                                placeholder="Type here..."
                                onChange={this.handleChangeScorecard('title')}
                            />
                            <Dropdown
                                className="dropdown-field mb-3"
                                title="Frequency"
                                dataCy="author"
                                width="fit-content"
                                data={ScoreCardTypes}
                                defaultIds={[scorecard.type ?? 0]}
                                onChange={this.handleChangeScorecard('type')}
                            />
                            <Input
                                className="input-field"
                                title="Description"
                                dataCy="description"
                                type="text"
                                as="textarea"
                                maxLength="80"
                                rows="3"
                                value={scorecard.data.description}
                                placeholder="Type here..."
                                onChange={this.handleChangeScorecard('description')}
                            />
                        </div>
                    </div>
                    <div className="detail-list mt-3" data-cy="quotasList">
                        <div className="d-flex-1 align-items-start dsl-b18 bold mb-2">Goals</div>
                        <div className="section d-flex">
                            <div className="d-flex-10">
                                <p className="dsl-m12 text-400 m-0">Goal</p>
                            </div>
                            <div className="d-none d-sm-flex d-flex-4 ps-3">
                                <p className="dsl-m12 text-400 m-0">Value type</p>
                            </div>
                            <div className="d-flex-4">
                                <p className="dsl-m12 text-400 m-0">Scale</p>
                            </div>
                            <div className="d-flex-1 edit d-h-end" />
                        </div>
                        <div className="section py-0">
                            {quotas?.length > 0 ? (
                                quotas.map((quota, index) => (
                                    <Quota editable data={quota} key={quota.id} index={index} onChange={this.handleChangeQuota(index)} onSelect={this.handleSelectMenu(quota)} />
                                ))
                            ) : (
                                <p className="dsl-m14 text-400 my-4">No Goals attached</p>
                            )}
                        </div>
                        <div className="d-flex jc-end p-3">
                            <Button className="px-0 my-0 auto-height" type="link" name="+ Attach Goal" onClick={this.handleAddQuotas} />
                        </div>
                    </div>
                </div>
                <Settings values={settings} isEditable expanded handleSelect={this.handleSettings} />

                <div className="mt-4 d-h-end">
                    <Button className="mr-3" name="Draft" disabled={this.props.data?.published ? false : disabled} type="low" onClick={this.handleSubmit(0)} />
                    <Button disabled={this.props.data?.published ? disabled : false} name="Publish" onClick={this.handleSubmit(1)} />
                </div>
            </>
        );
    }
}

Edit.propTypes = {
    authors: PropTypes.array,
    departments: PropTypes.array,
    competencies: PropTypes.array,
    categories: PropTypes.array,
    data: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        data: PropTypes.any,
        author_id: PropTypes.number,
    }),
    onModal: PropTypes.func,
    onSubmit: PropTypes.func.isRequired,
};

Edit.defaultProps = {
    authors: [],
    departments: [],
    competencies: [],
    categories: [],
    data: {
        id: 0,
        name: '',
        data: {},
        author_id: 0,
    },
    onModal: () => {},
    onSubmit: () => {},
};

export default Edit;
